import { connect, RenderFieldExtensionCtx, RenderManualFieldExtensionConfigScreenCtx } from 'datocms-plugin-sdk';
import { render } from './utils/render';
import 'datocms-react-ui/styles.css';
import { CustomFieldExtensionConfigScreen } from './entrypoints/FieldExtensionConfigScreen';
import { CustomFieldExtension } from './entrypoints/FieldExtension';

const FIELD_EXTENSION_ID = "dropdownConditionalDisabled";

connect(
{
  manualFieldExtensions() {
    return [
      {
        id: FIELD_EXTENSION_ID,
        name: 'Dropdown Conditional Disabled',
        type: 'addon',
        fieldTypes: ["string"],
        configurable: true,
        initialHeight: 0,
      },
    ];
  },
  renderFieldExtension(fieldExtensionId: string, ctx: RenderFieldExtensionCtx) {
    if (fieldExtensionId === FIELD_EXTENSION_ID) {
     
      render(<CustomFieldExtension ctx={ctx} />);
      
    }
  },
  renderManualFieldExtensionConfigScreen(
    fieldExtensionId: string,
    ctx: RenderManualFieldExtensionConfigScreenCtx,
  ) {
    render(<CustomFieldExtensionConfigScreen ctx={ctx} />);
  },
  
}
);

